import { Injectable } from '@angular/core';

import {
  NotificationRef,
  NotificationService,
} from '@progress/kendo-angular-notification';
import { NotifyComponent } from 'src/app/shared/components/notify/notify.component';
import { NotifyType } from '../enums/NotifyType';

@Injectable({
  providedIn: 'root',
})
export class AppNotifyService {
  private NOTIFY_MESSAGE = '';
  public get notifyMessage() {
    return this.NOTIFY_MESSAGE;
  }
  constructor(private notificationService: NotificationService) {}
  public notify(notifyType: NotifyType, message: string): void {
    let notificationRef: NotificationRef;
    if (notifyType === NotifyType.SUCCESS) {
      this.NOTIFY_MESSAGE = message;
      this.notificationService.show({
         content: message,
         hideAfter: 3000,
         cssClass: 'button-notification',
         animation: { type: 'slide', duration: 400 },
         position: { horizontal: 'right', vertical: 'top' },
         type: { style: 'success', icon: true },
         closable: false,
       });
      // notificationRef = this.notificationService.show({
      //  content: NotifyComponent,
      //  hideAfter: 5000,
      //  animation: { type: "slide", duration: 200 },
      //  position: { horizontal: "right", vertical: "top" },
      //  type: { style: "success", icon: false },
      //  closable: true,
      // });
    } else if (notifyType === NotifyType.ERROR) {
      this.NOTIFY_MESSAGE = message;
      this.notificationService.show({
        content: message,
        hideAfter: 3000,
        cssClass: 'button-notification',
        animation: { type: 'slide', duration: 400 },
        position: { horizontal: 'right', vertical: 'top' },
        type: { style: 'error', icon: true },
        closable: false
      });

      if (notificationRef) {
        notificationRef.content.instance.ignore.subscribe(() =>
          notificationRef.hide()
        );
      }
    } else if (notifyType === NotifyType.WARNING) {
      this.NOTIFY_MESSAGE = message;
      this.notificationService.show({
        content: message,
        hideAfter: 3000,
        cssClass: 'button-notification',
        animation: { type: 'slide', duration: 400 },
        position: { horizontal: 'right', vertical: 'top' },
        type: { style: 'warning', icon: true },
        closable: false
      });

      if (notificationRef) {
        notificationRef.content.instance.ignore.subscribe(() =>
          notificationRef.hide()
        );
      }
    } else if (notifyType === NotifyType.INFO) {
      this.NOTIFY_MESSAGE = message;
      this.notificationService.show({
        content: message,
        hideAfter: 3000,
        cssClass: 'button-notification',
        animation: { type: 'slide', duration: 400 },
        position: { horizontal: 'right', vertical: 'top' },
        type: { style: 'info', icon: true },
        closable: false
      });

      if (notificationRef) {
        notificationRef.content.instance.ignore.subscribe(() =>
          notificationRef.hide()
        );
      }
    }
  }
}
